import { StoreKeys } from '../../models/store-keys';
import { WorkflowModelInfosState } from './reducer/workflow-model-infos-reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObjectTypeWkf } from '../../models/ObjectTypeWkf';

export const selectWorkflowModelInfosFeature = createFeatureSelector<WorkflowModelInfosState>(StoreKeys.WORKFLOW_MODEL_INFOS);

export const selectWorkflowModelInfosTask = createSelector(selectWorkflowModelInfosFeature, state => state.datas[ObjectTypeWkf.TASK]);
export const selectWorkflowModelInfosProcess = createSelector(selectWorkflowModelInfosFeature, state => state.datas[ObjectTypeWkf.PROCESSUS]);
